export default "__VITE_ASSET__Cy_s1aqw__"